import { Component, OnInit, Input,
         Output, EventEmitter }    from '@angular/core';
import { FormGroup, FormControl, FormArray,
         FormBuilder, Validators } from '@angular/forms';

import { CsvService }              from '../../csv.service';
import { User }                    from '../../../../models/program/user';
import { BatchCommitInfo }         from '../../../../models/program/batch-commit-info';
import { BatchResponse }           from '../../../../models/program/batch-response';
import { Router }                  from '@angular/router';
import { ErrorService }            from '../../../../shared/services/error.service';

@Component({
  selector: 'app-batch-add-users-to-edition',
  templateUrl: './batch-add-users-to-edition.component.html',
  styleUrls: ['./batch-add-users-to-edition.component.less']
})

export class BatchAddUsersToEditionComponent implements OnInit {
  @Input() batchResponse: BatchResponse;
  @Output() loadSettingsFromBatch: EventEmitter<BatchCommitInfo> = new EventEmitter<BatchCommitInfo>();
  @Output() reset: EventEmitter<boolean> = new EventEmitter<boolean>();
  public teamAmount: number;
  public detectedUserAmount: number;
  public existingUsers: User[];
  public usersToMove: number[] = [];
  public events: any[] = [];
  public committed: boolean;
  public detectedNewUserAmount: number;
  public errors: string[];
  public saving: boolean;
  public sendWelcome = false;

  constructor(
    private router: Router,
    private errorService: ErrorService,
    private csvService: CsvService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.detectedUserAmount = this.batchResponse.user_count;
    this.detectedNewUserAmount = this.batchResponse.existing_users ? this.batchResponse.existing_users.length : 0;

    if (this.batchResponse.existing_users) {
      this.existingUsers = this.batchResponse.existing_users;
      this.setUsers(this.existingUsers);
    }
  }

  /**
   * Public methods
   */

  public moveUser(id: number, bool: boolean): void {
    console.log(id, bool);
    if (bool) {
      this.addUser(id);
    } else {
      this.removeUser(id);
    }
  }

  public resetData(bool: boolean): void {
    this.reset.emit(bool);
  }

  public continueToSubscriptionSettings() {
    this.loadSettingsFromBatch.emit({
      users_to_move: this.usersToMove,
      batch_ref: this.batchResponse.batch_ref
    } as BatchCommitInfo);
  }

  /**
   * Private Methods
   */

  private setUsers(arr: User[]): void {
    arr.forEach(user => this.addUser(user.id));
    console.log(this.usersToMove);
  }

  private addUser(id?: number): void {
    this.usersToMove.push(id);
  }

  private removeUser(id: number): void {
    this.usersToMove.splice(this.usersToMove.indexOf(id), 1);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/batch/batch-add-users-to-edition.component.ts